export const getGoogleRouteDistance = (legs: google.maps.DirectionsLeg[]) => {
  const distance = Math
    .round(legs.reduce((acc, { distance }) => (distance ? acc + distance.value : acc), 0) / 1000);

  return distance.toString(); // km
}
